module.exports = __webpack_public_path__ + "img/giftCertificate1_4.c5f7a201.png";